import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex, Icon, NakedButton, Text } from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';

import LinkButton from '@/v2/../components/LinkButton';
import {
  GOOGLE_MAPS_KEY,
  GOOGLE_MAPS_STATIC_API_URL,
} from '@/v2/../config/public';
import useBreakpoints, { isScreen } from '@/v2/../hooks/useBreakpoints';
import GoogleStaticMap from '@/v2/../shared/components/GoogleStaticMap';
import useSize from '@/v2/../shared/hooks/useSize';
import { UI } from '@/v2/types';
import Map from './components/Map';

const NoWrapBox = styled(Text)`
  white-space: nowrap;
`;

interface Props {
  propertyContent: Pick<
    UI.Property,
    'geolocation' | 'name' | 'address' | 'destination'
  >;
}

const HotelLocation = React.memo(({ propertyContent }: Props) => {
  const breakpoints = useBreakpoints();
  const smallScreen = isScreen(breakpoints)('xs', 'sm');
  const { width, ref } = useSize();
  // setting a max width because GM returns image dimensions of 680x180
  // which gets stretched on tablets
  const maxGMWidth = width > 640 ? 640 : width;
  const mapWidth = smallScreen ? maxGMWidth : 386;
  const center = `${propertyContent.geolocation.lat},${propertyContent.geolocation.lng}`;

  return (
    <ToggleContent
      toggle={(show) => {
        return (
          <Flex ref={ref} alignItems="center" flexDirection="column">
            <Box>
              {/* @ts-ignore */}
              <LinkButton onClick={show}>
                <GoogleStaticMap
                  options={{}}
                  alt={`Map of ${propertyContent.name}`}
                  apiKey={GOOGLE_MAPS_KEY}
                  url={GOOGLE_MAPS_STATIC_API_URL}
                  center={center}
                  width={mapWidth}
                  height={180}
                  zoom={15}
                  markers={center}
                />
              </LinkButton>
            </Box>
            <Flex
              width="100%"
              maxWidth={mapWidth}
              mt={3}
              alignItems="baseline"
              justifyContent="space-between"
            >
              <Box alignSelf="flex-start">
                <Icon name="hotel" mr={2} color="greys.steel" />
              </Box>
              <Text mr="2" fontSize="sm" color="greys.steel">
                {propertyContent.address}
              </Text>
              <NoWrapBox ml="auto">
                {/* @ts-ignore */}
                <NakedButton
                  color="brand.primary"
                  hoverColor="primaryDarker"
                  onClick={show}
                >
                  <Text fontSize="sm" textDecoration="underline">
                    View map
                  </Text>
                </NakedButton>
              </NoWrapBox>
            </Flex>
          </Flex>
        );
      }}
      content={(hide) => (
        // @ts-ignore
        <Map propertyContent={propertyContent} onClose={hide} />
      )}
    />
  );
});

export default HotelLocation;
